import { h, type FunctionalComponent } from 'vue'
import StatusDot, { type ConsoleColor } from './StatusDot'

// `dot` is accepted for existing callers. Every badge now leads with a dot.
type Props = { color?: ConsoleColor; dot?: boolean }

// Functional: rendered once per row in lists, so it carries no instance state.
const Badge: FunctionalComponent<Props> = (props, { slots }) => {
  const color = props.color ?? 'muted'
  // Amber is a fill colour. As text it needs the theme's readable amber.
  const text = color === 'accent' ? 'acctext' : color
  return h('span', { class: 'status-badge', style: { color: `var(--${text})` } }, [
    h(StatusDot, { color, size: 8 }),
    h('span', { class: 'status-badge-text' }, slots.default?.()),
  ])
}

Badge.props = { color: String, dot: Boolean }

export default Badge
